<template>
  <div
    ref="bannerRef"
    class="bg-static-default-hi border-static-default-low flex w-full items-center justify-center border-b-1 pl-24 pr-8"
    data-test="country-switch-redirection-banner"
  >
    <div class="group flex flex-1 items-center justify-center gap-x-10 py-16">
      <p class="text-static-default-hi body-2-bold text-left md:text-left">
        {{ message }}
      </p>
      <RevButton
        class="mr-8 min-w-[114px]"
        size="small"
        variant="primary"
        @click="handleRedirectionClick"
        >{{ buttonLabel }}</RevButton
      >
    </div>
    <RevButtonIcon
      aria-label="close"
      :icon="IconCross"
      variant="ghost"
      @click="handleClose"
    />
  </div>
</template>

<script setup lang="ts">
import { onUnmounted, ref } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconCross } from '@ds/icons/IconCross'
import { useIntersectionObserver } from '@vueuse/core'

const props = defineProps<{
  message: string
  buttonLabel: string
  trackingName: string
  trackingZone: string
  handleClose: () => void
  handleRedirection: () => void
}>()

const bannerRef = ref<HTMLElement | null>()

const { trackCountrySwitchClick, trackCountrySwitchBannerImpression } =
  useTracking()

const trackRedirection = () => {
  trackCountrySwitchClick({
    name: props.trackingName,
    zone: props.trackingZone,
  })
}

const handleRedirectionClick = () => {
  trackRedirection()
  props.handleRedirection()
}

function trackImpression() {
  trackCountrySwitchBannerImpression({
    name: props.trackingName,
    zone: props.trackingZone,
  })
}

const { stop } = useIntersectionObserver(bannerRef, ([{ isIntersecting }]) => {
  if (isIntersecting) {
    trackImpression()
  }
})

onUnmounted(() => {
  stop()
})
</script>
